import { fonts } from './fonts.js'
import { getHeadlessPool } from './headless-pool-for-board.js'
import { headlessModel } from './headless-model.js'

const protocol = 'http'
const host = 'localhost'
const path = '/internal-board-service-view'

export const pdf = async ({
  id = '',
  model = null,
  data = null,
  width: w = 0,
  height: h = 0,
  options = {} as any,
  context = {} as any
} = {}) => {
  const browser = (await getHeadlessPool().acquire()) as any

  if (!browser) {
    return
  }

  const { domain, user } = context.state

  var { model, base } = await headlessModel({ domain, id, model })
  const [fontsToUse, fontStyles] = await fonts(domain)

  model.fonts = fontsToUse
  model.fontStyles = fontStyles

  let { width, height } = model

  width = Number(width)
  height = Number(height)

  if (!w) {
    w = width
  }
  if (!h) {
    h = height
  }

  let ratio = Math.min(w / width, h / height)

  width = Math.floor(width * ratio)
  height = Math.floor(height * ratio)

  const port = process.env.PORT ? `:${process.env.PORT}` : ''
  const url = `${protocol}://${host}${port}${path}`
  const page = await browser.newPage()

  try {
    /* @remember-me width, height should be a integer */
    await page.setViewport({ width, height })
    await page.setRequestInterception(true)

    page.on('console', async msg => {
      console.log(`[headless ${msg.type()}] ${msg.text()}`)
    })

    page.on('pageerror', error => {
      console.log(`[headless pageerror] ${error.message}`)
      console.log(error.stack)
    })

    page.on('error', error => {
      console.log(`[headless fault] ${error}`)
      console.log(error.stack)
    })

    page.on('requestfailed', request => {
      console.log('Request failed:', request.url())
    })

    const token = await user?.sign() // TODO improve performance

    page.on('request', request => {
      if (request.url() === url) {
        request.continue({
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-things-factory-domain': domain?.subdomain,
            Authorization: 'Bearer ' + token
          },
          postData: JSON.stringify({
            model,
            base
          })
        })
      } else if (request.url().startsWith(`${protocol}://${host}${port}`)) {
        request.continue({
          headers: {
            ...request.headers(),
            'x-things-factory-domain': domain?.subdomain,
            Authorization: 'Bearer ' + token
          }
        })
      } else {
        request.continue()
      }
    })

    await page.goto(url)

    await page.evaluate(async data => {
      if (data) {
        // @ts-ignore
        s.data = data
      }

      // data 주입 후 강제 지연시킴.
      return new Promise(resolve => {
        // @ts-ignore
        requestAnimationFrame(() => resolve())
      })
    }, data)

    const pdf = await page.pdf({
      format: 'A4',
      ...options
    })
  } catch (error) {
    console.log(error)
  } finally {
    page.close()
    getHeadlessPool().release(browser)
  }

  return pdf
}
